const JOIN_CODE_PATTERN =
  /^[ABCDEFGHJKLMNPQRSTUVWXYZ23456789]{6}$/;

export function normalizeJoinCode(
  value: string,
): string {
  return value
    .trim()
    .replace(/\s+/g, "")
    .toUpperCase();
}

export function isValidJoinCode(
  value: string,
): boolean {
  return JOIN_CODE_PATTERN.test(
    normalizeJoinCode(value),
  );
}

export function readJoinCode(
  pathname: string,
  search: string,
): string | undefined {
  const pathMatch =
    pathname.match(
      /\/join\/([^/?#]+)/i,
    );

  const params =
    new URLSearchParams(
      search,
    );

  const raw =
    pathMatch?.[1] ??
    params.get("code") ??
    undefined;

  if (!raw) {
    return undefined;
  }

  const normalized =
    normalizeJoinCode(
      decodeURIComponent(raw),
    );

  return isValidJoinCode(
    normalized,
  )
    ? normalized
    : undefined;
}
